const model = {
  portugues: {
    zoom: "Zoom",
    saveBellaCloud: "Salvar no BellaCloud",
    share: "Compartilhe",
    extras: "Extras",
    download: "Download",
    resolution: "Resolução",
    sessions: "Partes",
    questionTitle: "Confira a entrevista que o Bella fez com a modelo:",
    navBar: [
      { name: "Fotos", val: 1, path: "photo" },
      { name: "Videos", val: 2, path: "video" },
      { name: "Making Of", val: 6, path: "making-of" },
      { name: "Lives", val: 7, path: "live" },
      { name: "Entrevista", val: 3, path: "perfil" },
      { name: "Wallpapers", val: 4, path: "wallpaper" },
      { name: "Créditos", val: 5, path: "credits" },
    ],
    subscribeNow: "Assine agora",
    soon: "Em breve",
    addAlbum: "Adicionar",
    newAlbum: "Novo álbum",
    saveAlbumInfo: "Clique no álbum para adicionar ou remover item",
    titleModalPlan: "Ainda não é sócio?",
    subtitleModalPlan: "Escolha o melhor plano para você e assine agora mesmo!",
    textBodyModalPlan: "Escolha o seu plano:",
    footer1ModalPlan: "Já é sócio?",
    footer2ModalPlan: "Faça seu Login",
    wallpaper: "Escolha o seu wallpaper:",
    quality: "Qualidade",
    viewProfile: "Veja Mais",
    textModalLogin1: "Contéudo exclusivo para",
    textModalLogin2: "sócios do <b>Clube Bella</b>",
    textModalLogin3: "FEITO PARA HOMEM RAIZ",
    textModalLogin4: "Freetour Clube Bella",
    textModalLogin5: "Eca, me tira daqui!",
    textModalLogin6: "Fazer parte do Clube Bella",
    textModalLogin7: "VER PRÉVIA DAS MODELOS NUAS",
    textModalLogin8: "ASSINE",
    textModalLogin9: "E TENHA ACESSO A",    
    textModalLogin10: "MAIS DE 300 MODELOS",
    textModalLogin7OldUser: "Clique aqui e renove agora",
    textModalLogin3OldUser: "Sua assinatura expirou. Não perca mais tempo",
    navBarPages: [
      { name: "Fotos", val: 0, path: "modelos" },
      { name: "Vídeos", val: 1, path: "videos" },
      { name: "Making Of", val: 2, path: "making-of" },
      { name: "Lives", val: 3, path: "lives" }
    ],    
    seeVideo: "Veja o vídeo",
    modalZoomTitle: "Quer ver cada detalhe em Alta Definição?",
    modalZoomText: "O recurso de Ampliar e Super Zoom são exclusivos para nossos assinantes dos planos Plus e Gold. Fique ainda mais próximo das nossas Bellas com a máxima qualidade visual.",
    modalZoomButton: "ASSINE OU FAÇA O UPGRADE AGORA",
    superZoomLabel: "Super Zoom",
    superZoomTooltip: "Arraste o mouse na foto para mover o super zoom",
    superZoomTooltipModal: "Toque / clique na foto para aplicar o super zoom"
  },
  ingles: {
    zoom: "Zoom",
    saveBellaCloud: "Save to BellaCloud",
    share: "Share",
    extras: "Extras",
    download: "Download",
    resolution: "Quality",
    sessions: "Sessions",
    questionTitle: "Check out the interview that Bella did with the model:",
    navBar: [
      { name: "Photos", val: 1, path: "photo" },
      { name: "Videos", val: 2, path: "video" },
      { name: "Making Of", val: 6, path: "making-of" },
      { name: "Lives", val: 7, path: "live" },
      { name: "Interview", val: 3, path: "perfil" },
      { name: "Wallpapers", val: 4, path: "wallpaper" },
      { name: "Credits", val: 5, path: "credits" },
    ],
    subscribeNow: "Subscribe now",
    soon: "Soon",
    addAlbum: "Add",
    newAlbum: "New album",
    saveAlbumInfo: "Click on the album to add or remove item",
    titleModalPlan: "Not a member yet?",
    subtitleModalPlan: "Choose the best plan for you and subscribe right now!",
    textBodyModalPlan: "Choose your plan:",
    footer1ModalPlan: "Already a member?",
    footer2ModalPlan: "Log in",
    wallpaper: "Choose your wallpaper:",
    quality: "Quality",
    viewProfile: "See More",
    textModalLogin1: "Exclusive content for",
    textModalLogin2: "<b>Bella club</b> members",
    textModalLogin3: "MADE FOR OLD SCHOOL MAN",
    textModalLogin4: "Freetour Bella Club",
    textModalLogin5: "Ew, get me outta here!",
    textModalLogin6: "Be part of Bella Club",
    textModalLogin7: "SEE PREVIEW OF NUDE MODELS",
    textModalLogin8: "SUBSCRIBE",
    textModalLogin9: "AND GET ACCESS",
    textModalLogin10: "TO OVER 300 MODELS",
    textModalLogin7OldUser: "Click here to renew now",
    textModalLogin3OldUser: "Your subscription has expired. Don’t waste any more time",
    navBarPages: [
      { name: "Photos", val: 0, path: "modelos" },
      { name: "Videos", val: 1, path: "videos" },
      { name: "Making Of", val: 2, path: "making-of" },
      { name: "Lives", val: 3, path: "lives" }
    ],    
    seeVideo: "See the video",
    modalZoomTitle: "Want to see every detail in High Definition?",
    modalZoomText: "The Zoom and Super Zoom features are exclusive to our Plus and Gold plan subscribers. Get even closer to our Bellas with the highest visual quality.",
    modalZoomButton: "SUBSCRIBE OR UPGRADE NOW",
    superZoomLabel: "Super Zoom",
    superZoomTooltip: "Drag the mouse over the photo to move the super zoom",
    superZoomTooltipModal: "Tap / click the photo to apply the super zoom"
  },
};

export default model;
